.cf{border:1px solid #ddd;}